import React, { useEffect, useState } from 'react'
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
function Index() {
  const authToken = localStorage.getItem('token');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [statics, setStatics] = useState([])
  const [recentUser, setRecentUser] = useState([]);
  const [recentStake, setRecentStake] = useState([]);

  const [recentWithdraw, setRecentWithdraw] = useState([]);
  const [tabelLoading, setTableLoading] = useState(false);

  useEffect(() => {
    const fetchProfileData = async () => {
      //console.log('Token ', authToken);
      try {
        const statics = await fetch(`${baseurl}/statics.php`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (statics.status === 429) {
          //  console.error("Rate limit exceeded. Please try again later.");
          return; // Stop further processing
        }

        const result = await statics.json();
        console.log('Static data', result.statistics);

        if (result.status) {

          setStatics(result.statistics);
          setRecentUser(result.recent_users);
          setRecentStake(result.recent_stake);
          setRecentWithdraw(result.recent_withdraw);

          setTableLoading(true);
        } else {
          // Handle any error condition
          setTableLoading(true);
        }

      } catch (error) {
        //  console.error('Fetch error:', error);
        setTableLoading(true);
      }
    };

    fetchProfileData();
  }, []);


  const handleProfileDataFetched = (data) => {
    console.log(data);

  };


  return (
    <>
      <Header>
        <Auth onProfileDataFetched={handleProfileDataFetched} />
        <div className="main-content app-content" >
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <div>
                <h4 className="mb-0">Hi, welcome back!</h4>

              </div>
            </div>
            {/* End Page Header */}
            {/* row */}
            <div className="row">
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <a href="/Clients">
                  <div className="card overflow-hidden sales-card bg-primary-gradient">
                    <div className="px-3 pt-3  pb-2 pt-0">
                      <div>
                        <h6 className="mb-3 fs-12 text-fixed-white">TOTAL USER</h6>
                      </div>
                      <div className="pb-0 mt-0">
                        <div className="d-flex">
                          <div>
                            <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                              {statics ? statics.total_user : '0'}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="compositeline" />
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-success-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">ACTIVE USER</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {statics ? statics?.active_user : '0'}
                          </h4>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline3" />
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-warning-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">PENDING USER </h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {statics ? statics?.pending_user : '0'}
                          </h4>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline4" />
                </div>
              </div>


              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-danger-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">BLOCK USER</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {statics ? statics.block_user : '0'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline2" />
                </div>
              </div>


            </div>
            {/* row closed */}


            {/* row closed */}
            {/* row opened */}
            <div className="row">
              <div className="col-xl-6 col-md-12 col-lg-12">
                <div className="card overflow-hidden">
                  <div className="card-header pb-1">
                    <h3 className="card-title mb-2">Recent User</h3>
                  </div>
                  <div className=" card-body">
                    <div className="card-body p-0 customers mt-1">
                      {tabelLoading ? (



                        <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                          <thead>
                            <tr>

                              <th className="wd-lg-25p">Name</th>
                              <th className="wd-lg-25p">Email</th>
                              <th className="wd-lg-25p">Join Date</th>
                            </tr>
                          </thead>

                          <tbody>
                            {recentUser.length > 0 ? (
                              recentUser.map((users, index) => (
                                <tr key={index}>
                                  <td> {users.name || 'N/A'} </td>
                                  <td> {users.email || '0'} </td>
                                  <td>
                                    {users.joidDate || 'N/A'}
                                  </td>

                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td>No Data Found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                      ) : (
                        <div className="text-center">
                          <div class="d-flex justify-content-center mb-4">
                            <div class="spinner-border" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-md-12 col-lg-6">
                <div className="card">
                  <div className="card-header pb-1">
                    <h3 className="card-title mb-2">Recentaly Stake</h3>
                  </div>
                  <div className=" card-body">
                    <div className="card-body p-0 customers mt-1">
                      {tabelLoading ? (



                        <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                          <thead>
                            <tr>
                              <th className="wd-lg-25p">Amount</th>
                              <th className="wd-lg-25p">Coin</th>
                              <th className="wd-lg-25p">Status</th>
                            </tr>
                          </thead>

                          <tbody>
                            {recentStake.length > 0 ? (
                              recentStake.map((stake, index) => (
                                <tr key={index}>
                                  <td> ${stake.amount || 'N/A'} </td>
                                  <td> {stake.stakeCoin || '0'} RAINO </td>
                                  <td> {stake.DateTime || 'N/A'} </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td>No Data Found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                      ) : (
                        <div className="text-center">
                          <div class="d-flex justify-content-center mb-4">
                            <div class="spinner-border" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                  </div>

                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-12">
                <div className="card card-table">
                  <div className=" card-header p-0 d-flex justify-content-between mt-3">
                    <h3 className="card-title mb-1 text-primary">Recent Withdraw </h3>
                  </div>
                  <div className="table-responsive country-table">
                    {tabelLoading ? (
                      <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                        <thead>
                          <tr>
                            <th className="wd-lg-25p">Name</th>
                            <th className="wd-lg-25p">Withdraw Amount</th>
                            <th className="wd-lg-25p">To Address</th>
                            <th className="wd-lg-25p">Txn Hash</th>
                            <th className="wd-lg-25p">Status</th>
                            <th className="wd-lg-25p">Date Time</th>
                          </tr>
                        </thead>

                        <tbody>
                          {recentWithdraw.length > 0 ? (
                            recentWithdraw.map((dataClient, index) => (
                              <tr key={index}>
                                <td>{dataClient.user_name || 'N/A'}</td>
                                <td>$ {dataClient.withdrawAmount || 'N/A'}</td>

                                <td> {dataClient.toAddress || 'N/A'} </td>
                                <td> {dataClient.txnHash || '0'} </td>
                                <td> {dataClient.status || 'N/A'} </td>
                                <td> {dataClient.requestTime || 'N/A'} </td>

                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td>No Data Found</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    ) : (
                      <div className="text-center">
                        <div class="d-flex justify-content-center mb-4">
                          <div class="spinner-border" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      </div>
                    )}


                  </div>
                </div>
              </div>
            </div>
            {/* row close */}
          </div>
        </div>
      </Header>

      <Footer />

    </>
  )
}

export default Index